/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ItemDisputationType } from '../../models/item-disputation-type';

export interface GetItemDisputationType$Params {
  id: string;
}

export function getItemDisputationType(http: HttpClient, rootUrl: string, params: GetItemDisputationType$Params, context?: HttpContext): Observable<StrictHttpResponse<ItemDisputationType>> {
  const rb = new RequestBuilder(rootUrl, getItemDisputationType.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ItemDisputationType>;
    })
  );
}

getItemDisputationType.PATH = '/items/{id}/item-disputation-type';
